module.exports = __webpack_public_path__ + "media/images/smart_phone/item/rate_1-7504448edd314eb684fec0839bc9d0c5.png";